import { createSlice } from '@reduxjs/toolkit';

import { LOCAL_STORAGE_THEME } from '@utilities';

export enum Theme {
	AUTO = 'auto',
	DARK = 'dark',
	LIGHT = 'light'
}

export interface UIState {
	theme: Theme;
}

export const initialState: UIState = {
	theme: (localStorage.getItem(LOCAL_STORAGE_THEME) as Theme) ?? Theme.AUTO
};

export const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		setTheme: (state, action) => {
			state.theme = action.payload;
		}
	}
});

export const { setTheme } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
